import { ReactNode } from "react";

import { CircleDisabledIcon, PersonStatusIcon, PersonSingleIcon } from "mds/icons";
import { SectionUserActivityStatus } from "store/selectors";

export const userActivityIcons: Record<SectionUserActivityStatus | "disabled", ReactNode> = {
  active: <PersonStatusIcon statusColor="green" />,
  inactive: <PersonStatusIcon statusColor="green" />,
  offline: <PersonSingleIcon />,
  disabled: <CircleDisabledIcon />,
};

export const isUserOnline = (status: SectionUserActivityStatus) =>
  status === SectionUserActivityStatus.ACTIVE || status === SectionUserActivityStatus.INACTIVE;
